import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 10,
  },
  scrollView: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 15,
  },
  spaceHeader: {
    marginTop: 30,
  },
  paymentText: {
    textAlign: 'center',
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 18,
    maxWidth: 200,
    alignSelf: 'center',
    color: Colors.GrayPallete.lightgrayThree,
  },
  boldText: {
    fontWeight: 'bold',
  },
  containerFilter: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 50,
  },
  debts: {
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 19,
    color: 'black',
  },
  buttonFilter: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  textFilter: {
    marginRight: 10,
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 14,
    color: Colors.RedPallete.red,
  },
  containerCard: {
    marginVertical: 30,
  },
  message: {
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 20,
    color: 'black',
    textAlign: 'center',
    marginTop: 10,
    fontFamily: 'TCCC-UnityText Bold',
  },
  paragraph: {
    fontSize: 10,
    fontWeight: '200',
    color: Colors.GrayPallete.lightgrayThree,
    textAlign: 'center',
    marginTop: 10,
    fontFamily: 'TCCC-UnityText Bold',
  },
  phone: {
    fontSize: 16,
    fontWeight: '400',
    color: Colors.GrayPallete.lightgrayThree,
    textAlign: 'center',
    marginTop: 10,
    fontFamily: 'TCCC-UnityText Bold',
  },
  containerQuestions: {
    padding: 15,
    marginBottom: 20,
    backgroundColor: 'white',
    color: 'black',
  },
  listItem: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 15,
    backgroundColor: 'white',
    borderBottomWidth: 1,
    borderColor: '#eee',
  },

  listItemSelected: {
    backgroundColor: '#f0f8ff',
  },

  checkbox: {
    width: 24,
    height: 24,
    borderWidth: 2,
    borderColor: Colors.RedPallete.red,
    marginRight: 15,
    justifyContent: 'center',
    alignItems: 'center',
  },

  checkboxFull: {
    width: 24,
    height: 24,
    borderWidth: 2,
    borderColor: Colors.RedPallete.red,
    backgroundColor: Colors.RedPallete.red,
    marginRight: 15,
    justifyContent: 'center',
    alignItems: 'center',
  },

  checkboxText: {
    fontSize: 16,
    color: 'white',
  },

  listItemText: {
    color: '#777',
    fontSize: 18,
    fontWeight: '600',
  },

  arrows: {
    color: '#777',
  },

  listItemSub1: {
    fontSize: 14,
    fontWeight: '600',
    color: Colors.RedPallete.red,
  },

  listItemSub: {
    fontSize: 14,
    color: '#777',
  },

  fixedButtonContainer: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0,
    alignItems: 'center',
  },

  spacer: {
    height: 80,
  },

  buttonWrapper: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    alignItems: 'center',
    paddingBottom: 20,
    paddingTop: 10,
    backgroundColor: 'transparent',
  },

  buttonBackground: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'white',
    zIndex: -1,
    borderTopWidth: 1,
    borderColor: '#ddd',
  },

  summaryBox: {
    backgroundColor: '#f9f9f9',
    borderRadius: 8,
    padding: 15,
    marginHorizontal: 20,
    marginBottom: 30,
  },

  summaryLine: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 6,
  },

  label: {
    fontSize: 14,
    color: 'black',
  },

  value: {
    fontSize: 14,
    color: 'black',
  },

  totalRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingHorizontal: 20,
  },
  totalText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#222',
  },

  sectionHeader: {
  backgroundColor: '#f5f5f5',
  paddingHorizontal: 16,
  paddingVertical: 12,
  borderBottomWidth: 1,
  borderBottomColor: '#e0e0e0',
  marginTop: 10,
},

sectionTitle: {
  fontSize: 16,
  fontWeight: 'bold',
  color: '#333',
  marginBottom: 4,
},

sectionSubtitle: {
  fontSize: 12,
  color: '#666',
  fontStyle: 'italic',
},

searchContainer: {
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: '#f8f8f8',
  borderRadius: 8,
  marginHorizontal: 16,
  marginVertical: 12,
  paddingHorizontal: 12,
  paddingVertical: 8,
  borderWidth: 1,
  borderColor: '#ddd',
},

searchIcon: {
  marginRight: 8,
},

searchInput: {
  flex: 1,
  fontSize: 14,
  color: '#333',
  paddingVertical: 4,
},

clearButton: {
  padding: 4,
  marginLeft: 8,
}
});
